import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/update-duck";

const { Types, Creators } = createActions(
  {
    request: ["id", "putData", "onSuccess", "onFailure"],
    success: [],
    failure: ["error"],
    reset: [],
  },
  { prefix: "UPDATE_INVOICE_ORDER_FOB_" }
);

export interface UpdateInvoiceOrderFOBState extends IState {}

const INITIAL_STATE: UpdateInvoiceOrderFOBState = {
  loading: false,
  error: null,
};

const request = (state: UpdateInvoiceOrderFOBState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: UpdateInvoiceOrderFOBState, action: ISuccessAction) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (state: UpdateInvoiceOrderFOBState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const updateInvoiceOrderFOB = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const UpdateInvoiceOrderFOBTypes = Types;
export const UpdateInvoiceOrderFOBActions = Creators;
